import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { WifiOff, X } from "lucide-react";
import { Link } from "react-router-dom";

const POLL_MS = 60000;

export const GpsOfflineAlert = () => {
  const [alerts, setAlerts] = useState([]);
  const [dismissedKey, setDismissedKey] = useState(() => sessionStorage.getItem("gps-alert-dismissed") || "");

  useEffect(() => {
    const load = () => api.gpsOfflineAlerts().then(r => setAlerts(r.alerts || [])).catch(() => {});
    load();
    const t = setInterval(load, POLL_MS);
    return () => clearInterval(t);
  }, []);

  const key = alerts.map(a => a.tech_id).sort().join(",");
  if (!alerts.length || key === dismissedKey) return null;

  const dismiss = () => { sessionStorage.setItem("gps-alert-dismissed", key); setDismissedKey(key); };

  return (
    <div className="border border-red-300 bg-red-50 rounded-sm px-4 py-3 flex items-start gap-3" data-testid="gps-offline-alert">
      <WifiOff className="w-5 h-5 text-red-600 mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-red-700 text-sm">GPS armada mati &gt; 30 menit ({alerts.length})</div>
        <div className="flex flex-wrap gap-1.5 mt-1.5">
          {alerts.map(a => (
            <span key={a.tech_id} className="text-[11px] px-2 py-0.5 rounded-sm bg-white border border-red-200 text-red-700"
              data-testid={`gps-offline-item-${a.tech_id}`}>
              <b>{a.tech_name}</b> · {a.age_min == null ? "belum pernah kirim" : `${a.age_min} mnt lalu`} · {a.open_wo} WO
            </span>
          ))}
        </div>
        <Link to="/live-map" className="text-[11px] text-red-700 underline mt-1.5 inline-block" data-testid="gps-offline-open-map">Buka Live Map</Link>
      </div>
      <button onClick={dismiss} className="text-red-400 hover:text-red-700" data-testid="gps-offline-dismiss"><X className="w-4 h-4" /></button>
    </div>
  );
};
